import React, { useMemo } from 'react'
import Wrapper from './components/Wrapper'
import { StaticPropsProvider } from '../../contexts/staticProps.context'

const ShoppingCart = props => {
  const {
    apiDetails: {
      staticData, staticDataCustom, staticDataWmo, taxInfo, props: staticProps,
    },
  } = props

  const tooltip = useMemo(
    () => ({
      warranty: staticData,
      tax: taxInfo,
      warrantyCustom: staticDataCustom,
      warrantyWmo: staticDataWmo,
    }),
    [staticData, staticDataCustom, staticDataWmo, taxInfo],
  )

  return (
    <StaticPropsProvider value={staticProps}>
      <Wrapper tooltip={tooltip} />
    </StaticPropsProvider>
  )
}

export default ShoppingCart
